import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { ReglasNegocioVinculacionConfiguracion } from '../_models/reglas-negocio-vinculacion-configuracion';
import { ReglasNegocioVinculacion } from '../_models/reglas-negocio-vinculacion';

@Injectable({
  providedIn: 'root'
})
export class ReglasNegocioVinculacionConfiguracionService {
  private masterService = AppSettings.rutServiciosAPL + '/api/reglasNegocioVinculacionConfiguracion';

  constructor(private authHttp: HttpClient, private autServicio: AutenticacionService) { }

  getAll() {
    return this.authHttp.get( `${this.masterService }`)
      .pipe( map( res => res as ReglasNegocioVinculacionConfiguracion[] ) );
  }

  getAllEnabled() {
    return this.authHttp.get( `${this.masterService }/enabled`)
      .pipe( map( res => res as ReglasNegocioVinculacionConfiguracion[] ) );
  }

  getAllById(idReglaNegocioVinculacionConfiguracion: string) {
    return this.authHttp.get( `${this.masterService }/${idReglaNegocioVinculacionConfiguracion}`)
      .pipe( map( res => res as ReglasNegocioVinculacionConfiguracion ) );
  }

  getByIdReglasNegocioVinculacion(idReglasNegocioVinculacion: string) {
    return this.authHttp.get( `${this.masterService }/reglaNegocioVinculacion/${idReglasNegocioVinculacion}`)
      .pipe( map( res => res as ReglasNegocioVinculacionConfiguracion[] ) );
  }

  update(f: ReglasNegocioVinculacionConfiguracion) {
    f.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.authHttp.put( `${this.masterService}/updateIndicadorHabilitado`, f )
      .pipe( map( res => res as ReglasNegocioVinculacionConfiguracion ) );
  }

  bulk(f: ReglasNegocioVinculacionConfiguracion[]) {
    f.map( t => {
      t.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
      return t;
    })
    return this.authHttp.post( `${this.masterService}`, f )
      .pipe( map( res => res as ReglasNegocioVinculacionConfiguracion[] ) );
  }
}
